import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import Divider from 'material-ui/Divider'
import TextField from 'material-ui/TextField'

import Select from 'components/Select'
import PropertyCombobox from '../PropertyCombobox'
import TenantCombobox from '../TenantCombobox'
import Comments from 'components/Comments'
import InvoiceDatePicker from '../InvoiceDatePicker'
import DueDatePicker from '../DueDatePicker'
import Lines from '../Lines'
import TransactionMemo from '../TransactionMemo'
import CheckBoxIsPaid from '../CheckBoxIsPaid'
import PaymentMethodSelect from '../PaymentMethodSelect'
import Attachments from 'components/Attachments'


import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { tenants } from 'selectors/entities'

let select = dirtyRead(
	(state, props) => ({
		transaction: doc(state, props.transactionID)
	, tenants: tenants(state)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		let expsFilled = (exps) => {
			for(let i = 0; i<exps.length; i++){
			  if(!exps[i].amount || !exps[i].category) return false
		  }
		  return true
		}
		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: "hidden"
				   , overflowX: "hidden"
					 , paddingBottom:"10px"
					 , paddingRight:"5px"
				}}
			>
				<div style={{width: "100%", padding:"10px 30px 0px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					<PropertyCombobox objectID={props.transactionID} />
					<TenantCombobox objectID={props.transactionID} />
				</div>
				{props.transaction.partyID && props.transaction.propertyID &&
					<div style={{width: "100%", padding:"0 30px 0px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
						<InvoiceDatePicker objectID={props.transactionID} />
						<DueDatePicker objectID={props.transactionID} />
						<TransactionMemo objectID={props.transactionID} />
						{/*<PaidAmount objectID={props.transactionID} />*/}
					</div>
				}
				{props.transaction.partyID && props.transaction.propertyID && <Lines objectID={props.transactionID} />}
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/transactionForm/InvoiceForm/LeftSide.js